<script setup>
import { computed } from "vue";

const props = defineProps({
  src: {
    type: String,
    required: false,
  },
  category: {
    type: String,
    required: false,
    validator(value) {
      return [
        "car",
        "family",
        "finances",
        "home",
        "home / moving",
        "medical / employer benefits",
        "pet",
        "travel",
        "wildcard",
        "wildcard!",
      ].includes(value.toLowerCase());
    },
  },
  alt: {
    type: String,
    required: false,
  },
});

const iconMap = {
  car: { url: "/illustrations/car.svg", alt: "Cartoon drawing of a car driving" },
  family: { url: "/illustrations/two-people.svg", alt: "Cartoon drawing of two people" },
  finances: {
    url: "/illustrations/finances.svg",
    alt: "Cartoon drawing of a money flower in a pot",
  },
  home: {
    url: "/illustrations/home.svg",
    alt: "Cartoon drawing of three tall buildings side by side",
  },
  "home / moving": {
    url: "/illustrations/home.svg",
    alt: "Cartoon drawing of three tall buildings side by side",
  },
  "medical / employer benefits": {
    url: "/illustrations/question-speech-bubbles.svg",
    alt: "Cartoon drawing of two speech bubbles, one with a question mark inside",
  },
  pet: { url: "/illustrations/pet-collar.svg", alt: "Cartoon drawing of a pet collar" },
  travel: {
    url: "/illustrations/travel.svg",
    alt: "Cartoon drawing of the sun setting over a body of water",
  },
  wildcard: {
    url: "/illustrations/hassle-helper.svg",
    alt: "Cartoon drawing of an outstretched hand with stars coming out like magic",
  },
  "wildcard!": {
    url: "/illustrations/hassle-helper.svg",
    alt: "Cartoon drawing of an outstretched hand with stars coming out like magic",
  },
};

const iconUrl = computed(() => {
  if (!props.category) {
    return props.src || iconMap.wildcard.url;
  }

  return props.src || iconMap[props.category.toLowerCase()].url;
});

const replaceImageSrc = (element, category = "wildcard") => {
  element.src = iconMap[category.toLowerCase()].url;
  element.alt = props.alt ?? iconMap[category.toLowerCase()].alt;
};
</script>

<template>
  <img
    v-if="iconUrl || category"
    class="object-contain"
    :src="iconUrl"
    :alt="alt"
    @error="replaceImageSrc($event.target, category)"
  />
</template>
